import LoginBox from "./LoginBox";
import TrackingBox from "./TrackingBox";

const faqs = [
    {
        q: "Whether Oxford is providing services (Express Mail) for all over India ?",
        a: "Yes, we are providing services for Stations other than Delhi as well as services (Express Mail) for Delhi and NCRs (Noida, Gurgaon, Ghaziabad and Faridabad)."
    },
    {
        q: "Whether Oxford is providing services (BulkMail and FastMail) for out of Delhi stations?",
        a: "Yes, we are providing services (BulkMail and FastMail) for the cities and towns."
    },
    {
        q: "Which are the stations going to be added , where the services (BulkMail and FastMail) going to be started?",
        a: "We are going to start the services (BulkMail and FastMail) in (list of stations are to be added)."
    },
    {
        q: "Whether the discounts are offered on heavy volumes?",
        a: "Yes, the discounts are offered on heavy volumes. Please call us at 011-26443452, 30821569, 41606841, 41606842 and speak to Sales Deptt. Or send us your details thru the enquiry form."
    },
    {
        q: "Whether the wedding cards or invitation cards are delivered thru Bulk Mail or Fast Mail or not?",
        a: "Yes, we are delivering wedding invitation cards and invitation cards for other functions by booking under BulkMail and FastMail."
    },
    {
        q: "Is it possible to track the Delivery Results thru the site, by just putting the Tracking No.?",
        a: "Yes, anyone who has booked pkts. is issued a Docket no. You can check details using TRACKING."
    },
    {
        q: "Where can I find the applicable tariff for your services?",
        a: "Please contact Oxford Head Office or call Sales Deptt. Or send your details through enquiry form."
    },
    {
        q: "Do you provide a service to the location of my choice?",
        a: "Yes, please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "Are there any commodities banned on your services?",
        a: "Yes, please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "Where can I find the Customs requirements for my international shipments?",
        a: "Please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "Where can I find the Regulatory requirements for my domestic shipments?",
        a: "Please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "I would like to use your services. Can you send your representative?",
        a: "Yes, please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "How can I change the address on a shipment?",
        a: "Please contact Oxford Head Office or Sales Deptt."
    },
    {
        q: "Do you accept jewellery, precious stones or valuables?",
        a: "No, because they are Banned Commodities."
    }
];

export default function FAQAccordion() {
    return (
        <>
            <section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* SIDEBAR */}
                        <div className="col-lg-3">

                            <TrackingBox />
                            <LoginBox />

                            {/* Contact */}
                            <div className="contact-card">
                                <div className="contact-title">Contact</div>

                                <div className="contact-item">
                                    <div className="contact-icon phone">
                                        <i className="fa fa-phone"></i>
                                    </div>
                                    <a href="tel:01141606842">+91 96672 33072</a>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">oxford_express@yahoo.co.in</a>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">info@oxfordexp.com</a>
                                </div>
                            </div>
                        </div>

                        {/* CONTENT */}
                        <div className="col-lg-9">
                            <div className="p-4 pt-0">
                                <div className="accordion" id="accordionExample">
                                    {faqs.map((item, index) => (
                                        <div className="accordion-item mb-3" key={index}>

                                            <h2 className="accordion-header" id={`heading${index}`}>
                                                <button
                                                    className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded={index === 0 ? "true" : "false"}
                                                    aria-controls={`collapse${index}`}
                                                >
                                                    {item.q}
                                                </button>
                                            </h2>

                                            <div
                                                id={`collapse${index}`}
                                                className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                                aria-labelledby={`heading${index}`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body">
                                                    {item.a}
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>

    );
}